import React, {
  createContext,
  useContext,
  useEffect,
  useState,
  useCallback,
} from "react";
import { useAuth } from "./AuthContext";
import { fetchMutualLikes as fetchMutualLikesApi } from "../api_calls/MutalLikesApi";

const MutualLikesContext = createContext();

export function MutualLikesProvider({ children }) {
  const { user } = useAuth();
  const [mutualLikes, setMutualLikes] = useState([]);
  const [loading, setLoading] = useState(true);

  // ✅ Extracted fetch logic into a stable function
  const fetchMutualLikes = useCallback(async () => {
    if (!user?.user_id) return;
    setLoading(true);
    try {
      const likes = await fetchMutualLikesApi(user.user_id);
      setMutualLikes(likes);
    } finally {
      setLoading(false);
    }
  }, [user?.user_id]);

  // ✅ Run on mount & when user changes
  useEffect(() => {
    fetchMutualLikes();
  }, [fetchMutualLikes]);

  return (
    <MutualLikesContext.Provider
      value={{ mutualLikes, loading, refreshMutualLikes: fetchMutualLikes }}
    >
      {children}
    </MutualLikesContext.Provider>
  );
}

export function useMutualLikes() {
  return useContext(MutualLikesContext);
}
